import { CaseDiagnosis as OpenAPICaseDiagnosis } from "pwapi";

import { CptCode } from "./CptCode";

export type CaseDiagnosis = Omit<OpenAPICaseDiagnosis, "cpt_codes"> & {
  readonly cpt_codes?: Array<CptCode>;
};

export namespace CaseDiagnosis {
  export enum source {
    AI = "ai",
    SCREEN = "screen",
    FINALIZE = "finalize",
    LIS_FINALIZED = "lis-finalized",
    COMMENT = "comment",
    AMEND = "amend",
    ADDEND = "addend",
    CORRECTION = "correction",
  }
}
